module.exports = __webpack_public_path__ + "static/JosefinSans-Regular-aff001b45565556d667c11fe85cada0d.ttf";